import { render } from "./EventsPage.vue?vue&type=template&id=5a4122eb&scoped=true&ts=true"
import script from "./EventsPage.vue?vue&type=script&lang=ts"
export * from "./EventsPage.vue?vue&type=script&lang=ts"

import "./EventsPage.vue?vue&type=style&index=0&id=5a4122eb&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a4122eb"]])

export default __exports__